/**
 * FlagStripe — thin patriotic 3-band accent (red / white / blue) that lives at
 * the top of the Sacrifice hero and the bottom of the Legacy Wall page. Pure
 * CSS + a subtle shimmer sweep every 6s so it feels alive without shouting.
 */
export default function FlagStripe({ position = "top", "data-testid": testId }) {
  return (
    <div
      data-testid={testId || `flag-stripe-${position}`}
      aria-hidden="true"
      className="relative w-full flex overflow-hidden pointer-events-none"
      style={{ height: 6 }}
    >
      <div style={{ flex: 1, background: "#B32027" }} />
      <div style={{ flex: 1, background: "#F5EFE0" }} />
      <div style={{ flex: 1, background: "#0B1F3A" }} />
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background: "linear-gradient(90deg,transparent 0%,transparent 40%,rgba(255,255,255,0.9) 50%,transparent 60%,transparent 100%)",
          animation: "flagShimmer 6s linear infinite",
        }}
      />
      <style>{`
        @keyframes flagShimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
